(() => {

  const FilterFunctions = async () => {
    var filterAccordian = document.querySelectorAll('.collection-filter__title'), filteringToggle = document.querySelector('.FitlerIconTxt'), 
        filtersClose = document.querySelector('.FiltersCloseInit'), filterOverlay = document.querySelector('.filtersOverLay'), 
        viewResults = document.querySelector('.viewResults'), InheritSize = document.querySelectorAll('.SizeLabelInheritWp'),
        atcButton= document.querySelectorAll('#CollectionAjaxContent .color-swatches .colorIsActive [type="radio"]');
    if(filterAccordian.length > 0){
      filterAccordian.forEach(function(accrodian){
        accrodian.addEventListener('click',function(e){
          e.preventDefault();
          var objj=this;
          // filterAccordian.forEach(function(filAcc){ if(filAcc != objj){filAcc.parentNode.classList.remove('toggle_accordian');} })
          this.parentNode.classList.toggle('toggle_accordian');
        })
      })
    }
    if(filteringToggle){
      filteringToggle.addEventListener('click',function(e){
        e.preventDefault();
        this.closest('.FiltersMNInit').querySelector('.FiltersInitWrpr').classList.add('toggle_filter');
        document.body.classList.add('filterDrawerActive');
      })
    }
    if(filtersClose){
      filtersClose.addEventListener('click',function(e){
        e.preventDefault();
        this.parentNode.classList.remove('toggle_filter');
        document.body.classList.remove('filterDrawerActive');
      })
    }
    if(filterOverlay){
      filterOverlay.addEventListener('click',function(e){
        e.preventDefault();
        document.querySelector('.FiltersInitWrpr').classList.remove('toggle_filter');
        document.body.classList.remove('filterDrawerActive');
      })
    }
    if(viewResults){
      viewResults.addEventListener('click',function(e){
        e.preventDefault();
        this.closest('.FiltersMNInit').querySelector('.FiltersInitWrpr').classList.remove('toggle_filter');
        document.body.classList.remove('filterDrawerActive');
      })
    }
    if(InheritSize){
      InheritSize.forEach((evt)=>{ evt.addEventListener('click', (target)=>{ target.preventDefault(); if( target.currentTarget.hasAttribute('js-bra-size') ){ target.currentTarget.classList.toggle('active'); if( target.currentTarget.classList.contains('active') ){ let ElmBraFound = target.target.closest('.filterGridMNFlick').querySelectorAll('.BraSizeAppearance'); ElmBraFound.forEach((evt)=>{ evt.style.display = 'none'; }); }else{ let ElmBraFound = target.target.closest('.filterGridMNFlick').querySelectorAll('.BraSizeAppearance'); ElmBraFound.forEach((evt)=>{ evt.style.display = 'block'; }); } }else if( target.currentTarget.hasAttribute('js-underwear-size') ){ target.currentTarget.classList.toggle('active'); if( target.currentTarget.classList.contains('active') ){ let ElmUnderWearFound = target.target.closest('.filterGridMNFlick').querySelectorAll('.UnderWearSizeAppearance'); ElmUnderWearFound.forEach((evt)=>{ evt.style.display = 'none'; }); }else{ let ElmUnderWearFound = target.target.closest('.filterGridMNFlick').querySelectorAll('.UnderWearSizeAppearance'); ElmUnderWearFound.forEach((evt)=>{ evt.style.display = 'block'; }); } } }); });
    }
  }

  
  const removeFilters = async () =>{
    var reset_filters = document.querySelector('.resetfilters');
    if(reset_filters){
      reset_filters.addEventListener('click',function(e){
        e.preventDefault();
        var mainObjj = this; let discountTab;
        var collection_url = this.querySelector('.resetFilterAjaxBase').dataset.link;
        if( document.querySelectorAll('#tabs__containerDiscount').length > 0 ){
          discountTab = document.querySelector('#tabs__containerDiscount').dataset.sectionId;
        }
        if(window.location.href.includes('filter')){
          this.querySelector('.resetFilterAjaxBase').classList.add('btn--loading');
          fetch(collection_url+'?section_id=new-collection')
          .then(response => response.text())
          .then(data =>{
            const filter_html = new DOMParser().parseFromString(data,'text/html').querySelector('#CollectionFiltersSection');
            window.history.replaceState('','',collection_url);
            document.querySelector('.FiltersInitWrpr').classList.remove('toggle_filter');
            document.body.classList.remove('filterDrawerActive','FilteringDesignActive','SizeFiltersActive','ColorFiltersActive');
            mainObjj.querySelector('.resetFilterAjaxBase').classList.remove('btn--loading');
            document.querySelector('#CollectionFiltersSection').outerHTML = filter_html.outerHTML;
            $('.CountPDInit').addClass('hide');
            $('.ViewResultsCount').html('View Results');
            FilterFunctions();custom_discount();
            // theme.sections.register('collection-filter', theme.CollectionFilter);
            theme.sections.reinit('collection-filter');
            document.querySelectorAll('[section="collection-blocks"] .IndexGridLayoutWp').forEach((product)=>{
              product.querySelectorAll('.size-swatches .variant-input label').forEach(function(label){
                if(label.classList.contains('disabled')){
                  label.parentNode.classList.add('hide');
                }
              })
            });
          })

          if( document.querySelectorAll('#tabs__containerDiscount').length > 0 ){
            fetch(`${collection_url}?section_id=${discountTab}`)
            .then(response => response.text())
            .then(resulttab =>{
              const tabs_html = new DOMParser().parseFromString(resulttab,'text/html').querySelector('#tabs__containerDiscount');
              document.querySelector('#tabs__containerDiscount').innerHTML = tabs_html.innerHTML;
            }) 
          }
        }else{
          document.querySelector('.FiltersInitWrpr').classList.remove('toggle_filter');
          document.body.classList.remove('filterDrawerActive');
        }      
      })
    }
  }

  const custom_discount = async ()=>{
    document.querySelectorAll(`[data-rule-filter]`).forEach((elm)=>{
      elm.addEventListener('click', (target)=>{
        target.preventDefault();
        if ( target.currentTarget.classList.contains('active') ){
          return false;
        }else{
          let offpercentage = target.currentTarget.getAttribute('data-rule-filter'); 
          if( document.querySelectorAll(`[map-discount-filter="${offpercentage}"]`).length > 0){
            document.querySelectorAll(`[name="filter.v.m.custom.variant_discount"]`).forEach((elm)=>{elm.checked = false});
            target.target.closest('.disocunts__tabs').classList.add('enabled');
            document.querySelector(`[map-discount-filter="${offpercentage}"]`).click();
          }
        }
      })
    });
  }

  const getDiscounted = async ()=>{
    let discountTabFetch,collection_urlFetch;
    collection_urlFetch = document.querySelector('.resetFilterAjaxBase').dataset.link;
    if( document.querySelectorAll('#tabs__containerDiscount').length > 0 ){
      discountTabFetch = document.querySelector('#tabs__containerDiscount').dataset.sectionId;
      fetch(`${collection_urlFetch}?section_id=${discountTabFetch}`)
      .then(response => response.text())
      .then(resulttab =>{
        const tabs_html = new DOMParser().parseFromString(resulttab,'text/html').querySelector('#tabs__containerDiscount');
        document.querySelector('#tabs__containerDiscount').innerHTML = tabs_html.innerHTML;
        let FetchUrl = window.location.href,sizeFilterArray=[];
        if(FetchUrl.includes('&')){ var spliterLink = FetchUrl.split('?')[1].split('&'); }
        else{ var spliterLink = [FetchUrl.split('?')[1]] }
        spliterLink.forEach(function(link){
          if(link.split('=')[0] == 'filter.v.m.custom.variant_discount'){ sizeFilterArray.push(link) } 
        })
        for (var i=0; i<sizeFilterArray.length; i++){
          document.querySelector(`[data-rule-filter="${sizeFilterArray[i].split('=')[1]}"]`).classList.add('active');
        }
        custom_discount();
      })       
    }    
  }
  
  document.addEventListener('DOMContentLoaded', function(){
    FilterFunctions();
    removeFilters();
    custom_discount();
    document.addEventListener('collection:reloaded', FilterFunctions);
    document.addEventListener('collection:reloaded', removeFilters);
    document.addEventListener('collection:reloaded', getDiscounted);
    document.addEventListener('collection:reloaded', custom_discount);
  });
  
})();
